import React from "react";
import PropTypes, { bool } from "prop-types";
import { classes } from "../utils/classes";
import pureFC from "../utils/pureFC";

const FieldHint = ({ isActive = false, className, ...props }) => (
	<span
		className={classes("field__hint", isActive && "field__hint--active", className)}
		{...props}
	/>
);

FieldHint.propTypes = {
	isActive: bool,
	className: PropTypes.string,
};

export default pureFC(FieldHint);
